<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     工位管理
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="pp-station header-padding">
    <f-page-header />

    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item lg">
          <f-search-input v-model="query.keyword" @change="fetchData(1)" />
        </span>
      </div>

      <div class="toolbox">
        <el-button type="success" icon="el-icon-plus" @click="editS()">新建工位</el-button>
        <el-button type="success" icon="el-icon-folder-add" plain @click="importShow = true">导入</el-button>
      </div>
    </div>

    <el-card v-loading="loading" class="table-card" shadow="never">
      <el-table
        ref="listTable"
        :data="list"
        size="medium"
        class="padding-small"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="60"></el-table-column>

        <el-table-column label width="60">
          <template slot-scope="scope">
            <f-image class="avatar" :src="scope.row.qr_code_url"></f-image>
          </template>
        </el-table-column>

        <el-table-column label="工位编码" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link :underline="false" @click="toDetail(scope.row)">{{scope.row.station_no}}</el-link>
          </template>
        </el-table-column>

        <el-table-column label="工位名称" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link :underline="false" @click="toDetail(scope.row)">{{ scope.row.station_title }}</el-link>
            <el-tag v-if="scope.row.is_maintain" type="danger" size="mini">维护中</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="关联设备" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link :underline="false" @click="toDetail(scope.row)">{{ scope.row.equip_name }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="允许新绑定" min-width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.bind_enable"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="changeEnable(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column min-width="280">
          <div slot="header">
            <el-row>
              <el-col :span="12">已绑定操作员</el-col>
              <el-col :span="12">已绑定质检员</el-col>
            </el-row>
          </div>
          <template slot-scope="scope">
            <el-popover placement="left" width="400" trigger="click">
              <div class="font-md mb">{{ scope.row.station_title }}</div>
              <el-table
                ref="membersTable"
                :data="scope.row.binder"
                tooltip-effect="dark"
                class="padding-small"
                style="width: 100%"
                max-height="500"
              >
                <el-table-column type="index" label="#" width="50" />

                <el-table-column label="成员" width="60">
                  <template slot-scope="item">
                    <f-user-avatar :user="item.row"></f-user-avatar>
                  </template>
                </el-table-column>

                <el-table-column show-overflow-tooltip>
                  <template slot-scope="item">{{item.row.username}}</template>
                </el-table-column>

                <el-table-column label="权限" width="100">
                  <template slot-scope="item">
                    <span v-if="item.row.role == 'operator'">{{ '操作' }}</span>
                    <span v-if="item.row.role == 'inspector'">{{ '质检' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60">
                  <template slot-scope="item">
                    <el-popconfirm
                      :title="'即将删除' + item.row.username + '绑定，是否继续？'"
                      @confirm="unbind(item.row)"
                    >
                      <el-button slot="reference" type="text">删除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>

              <div slot="reference" role="button">
                <el-row>
                  <el-col :span="12">
                    <f-user-avatar
                      v-if="scope.row.operators.length"
                      :user="scope.row.operators[0]"
                      :preview="false"
                    />
                    <f-user-avatar
                      v-if="scope.row.operators.length > 1"
                      class="ml-xs"
                      :user="scope.row.operators[1]"
                      :preview="false"
                    />
                    <f-user-avatar
                      v-if="scope.row.operators.length > 2"
                      class="ml-xs"
                      :user="scope.row.operators[2]"
                      :preview="false"
                    />
                    <span
                      v-if="scope.row.operators.length > 1"
                      class="ml-xs"
                    >共{{ scope.row.operators.length }}人</span>
                    <span v-if="scope.row.operators.length === 1" class="ml-xs">
                      {{ scope.row.operators[0].username
                      }}
                    </span>
                  </el-col>
                  <el-col :span="12" :offset="!scope.row.operators.length ? 12 : 0">
                    <f-user-avatar
                      v-if="scope.row.inspectors.length"
                      :user="scope.row.inspectors[0]"
                      :preview="false"
                    />
                    <f-user-avatar
                      v-if="scope.row.inspectors.length > 1"
                      class="ml-xs"
                      :user="scope.row.inspectors[1]"
                      :preview="false"
                    />
                    <f-user-avatar
                      v-if="scope.row.inspectors.length > 2"
                      class="ml-xs"
                      :user="scope.row.inspectors[2]"
                      :preview="false"
                    />
                    <span v-if="scope.row.inspectors.length > 1" class="ml-xs">
                      共{{ scope.row.inspectors.length
                      }}人
                    </span>
                    <span v-if="scope.row.inspectors.length === 1" class="ml-xs">
                      {{ scope.row.inspectors[0].username
                      }}
                    </span>
                  </el-col>
                </el-row>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="160" align="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="$router.push('/mes/progress?stationid=' + scope.row.stationid)"
            >查工单</el-button>
            <el-popover
              placement="left-start"
              width="120"
              trigger="click"
              popper-class="tool-pop"
              :visible-arrow="false"
            >
              <div
                class="pop-item"
                role="button"
                @click="$router.push('/pp/print?stationid=' + scope.row.stationid)"
              >打印二维码</div>
              <div class="pop-item" role="button" @click="editS(scope.row)">编辑</div>
              <div class="pop-item" role="button" @click="deleteOne(scope.row)">删除</div>
              <i class="el-icon-more font-md ml mr-sm text-muted" slot="reference" role="button"></i>
            </el-popover>
          </template>
        </el-table-column>

        <template slot="empty">
          <img class="image huger mt-lg" src="@/assets/empty.png" />
          <div class="font-md mb-hg">暂无数据</div>
        </template>
      </el-table>
    </el-card>

    <f-table-footer
      checkbox
      :list="list"
      :selection="multiSelection"
      @toggle="toggleAll"
      :total="total"
      :pindex.sync="query.pindex"
      :psize.sync="query.psize"
      @change="fetchData"
    >
      <template slot="left">
        <el-button plain :disabled="multiSelection.length === 0" size="mini" @click="deleteMulti">删除</el-button>
        <el-button class="ml-lg" plain :disabled="total === 0" size="mini" @click="exportStation">导出</el-button>
      </template>
    </f-table-footer>

    <pp-station-import v-if="importShow" :show.sync="importShow" @submit="fetchData(1)" />

    <new-station
      v-if="editShow"
      :show.sync="editShow"
      :stationid="activeStationid"
      @success="fetchData(1)"
    />
  </div>
</template>

<script>
import {
  getStationListApi,
  stationDelApi,
  exportStationApi,
  postStationApi,
  unbindApi,
} from "@/api/pp/stationApi";

export default {
  name: "PpStation",

  components: {
    PpStationImport: () => import("@/views/pp/components/PpStationImport"),
    NewStation: () => import("@/views/pp/components/NewStation"),
  },

  data() {
    return {
      activeStationid: null,
      editShow: false,
      importShow: false,
      query: {
        keyword: "",
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      list: [],
      multiSelection: [],
      total: 0,
      loading: false,
    };
  },

  computed: {},

  created() {
    this.fetchData(1);
  },

  methods: {
    fetchData(page, loading = true) {
      if (page) this.query.pindex = page;
      if (loading) this.loading = true;
      getStationListApi(this.query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.list.forEach((item) => {
            item.binder = item.operators.concat(item.inspectors);
          });
          this.total = res.data.total;
        }
      });
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
    },

    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    editS(row) {
      this.activeStationid = row ? row.stationid : null;
      document.body.click()
      this.editShow = true;
    },

    changeEnable(row) {
      const station = {
        station_no: row.station_no,
        stationid: row.stationid,
        station_title: row.station_title,
        equipid: row.equipid,
        bind_enable: row.bind_enable,
      };
      postStationApi(station).then((res) => {
        if (!res.errno) {
          this.$message.success("工位编辑成功");
        } else {
          const arr = this.list.map((i) => i.stationid);
          const index = arr.indexOf(row.stationid);
          let sub = Object.assign({}, row, {
            bind_enable: row.bind_enable ? 0 : 1,
          });
          this.list.splice(index, 1, sub);
          this.$message.error(res.message);
        }
      });
    },

    deleteOne(item) {
      if (this.editShow) return;
      this.$confirm(
        `即将删除工位<span class="text-primary"> ${item.station_no}</span>，是否继续 ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          stationDelApi({ stationids: [item.stationid] }).then((res) => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("工位删除成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    deleteMulti() {
      let tmp = this.multiSelection.map((v) => v.stationid);
      this.$confirm(
        `即将删除<span class="text-primary"> ${tmp.length}</span> 个工位，是否继续 ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          stationDelApi({ stationids: tmp }).then((res) => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("工位删除成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    unbind(row) {
      const temp = {
        stationid: row.stationid,
        uid: row.uid,
        role: row.role,
      };
      unbindApi(temp).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.$message.success("解绑成功！");
          this.fetchData();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    exportStation() {
      exportStationApi(this.query).then((res) => {
        if (!res.errno) {
          window.open(res.data.url);
          this.$message.success("工位导出成功！");
        }
      });
    },

    toDetail(row) {
      const { stationid } = row;
      const _this = this;
      this.$sdetail({
        stationid,
        handleChange: () => {
          _this.fetchData();
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pp-station {
  position: relative;
}
</style>
